import React from 'react';
import QuienesSomosIndustrial from '../industrial/QuienesSomosIndustrial';
import PageHeader from '../industrial/PageHeader';
import SEO from '../SEO';
import { breadcrumbSchema } from '../../utils/structuredData';

const QuienesSomosPage: React.FC = () => {
  const breadcrumbs = breadcrumbSchema([
    { name: 'Inicio', url: 'https://junisama.com.co' },
    { name: 'Quiénes Somos', url: 'https://junisama.com.co/quienes-somos' }
  ]);

  return (
    <>
      <SEO
        title="Quiénes Somos | Junisama - 10+ Años en Baños Portátiles | Empresa Líder Colombia"
        description="Junisama Inversiones S.A.S - Líderes en alquiler de baños portátiles en Colombia desde 2014. Más de 500 eventos exitosos. Equipo profesional certificado ISO14001. Servicio premium para festivales, bodas y eventos corporativos. Cobertura nacional."
        keywords="empresa baños portátiles Colombia, Junisama Inversiones, historia junisama, experiencia sanitarios portátiles, empresa certificada ISO14001, líder baños portátiles, equipo profesional eventos"
        url="/quienes-somos"
        structuredData={breadcrumbs}
      />
      <PageHeader
        title="NUESTRA"
        titleHighlight="EMPRESA"
        subtitle="Especialistas en infraestructura sanitaria portátil con más de una década de experiencia. Soluciones integrales para eventos de cualquier magnitud."
        backgroundImage="/images/services/operarios.webp"
      />
      <QuienesSomosIndustrial />
    </>
  );
};

export default QuienesSomosPage;